/* eslint-disable */
import { matchPath } from 'react-router-dom';
// tslint:disable-next-line:class-name
export class _Route {
    constructor(path) {
        Object.defineProperty(this, "path", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.path = path;
    }
    compile(params) {
        let compiled = this.path;
        if (!params) {
            return compiled;
        }
        Object.keys(params).forEach((key, _) => {
            compiled = compiled.replace(`:${key}`, params[key]);
        });
        return compiled;
    }
    matchPath(path) {
        return !!matchPath(this, path);
    }
    matchPathWithParams(path, params) {
        const compiled = this.compile(params);
        return !!matchPath(compiled, path);
    }
    with() {
        return this;
    }
}
export function Route(path) {
    return new _Route(path);
}
// tslint:disable-next-line:class-name
export class _RouteGroup {
    constructor(routes) {
        Object.defineProperty(this, "routes", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.routes = routes;
    }
    matchPath(path) {
        return !!this.routes.find((r) => r.matchPath(path));
    }
}
export function RouteGroup(routes) {
    return new _RouteGroup(routes);
}
